<template>
	<div class="question">
		<div class="optionMode">
			<div class="modeName">
				<span>{{ convertNumber(cur) }}、{{ titTypeObj[question.type] }}</span>
				<span class="score done1">{{ `（${question.score}分）` }}</span>
			</div>
			<div class="num">
				<span class="done">{{ cur }}</span> / <span>{{ total }}</span>
			</div>
		</div>
		<div class="questionTitle">{{ `${cur}. ${question.title}` }}</div>
	</div>
</template>

<script>
export default {
	props: {
		question: {
			type: Object,
			default: () => ({ type: 0, title: '' })
		},
		cur:{
			type:Number,
			default:()=>{return 0}
		},
		total:{
			type:Number,
			default:()=>{return 0}
		}
	},
	// 0判断题	1单选题	2多选题	3简答题
	data() {
		return {
			titTypeObj: {
				3: '判断题',
				1: '单选题',
				2: '多选题',
				4: '简答题'
			}
		};
	},
	computed: {
		convertNumber() {
			return (num) => {
				const arr = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
				const numStr = num.toString();
				let result = '';
				for (let char of numStr) {
					const index = parseInt(char) - 1
					if (index >= 0 && index < arr.length) {
						result += arr[index]
					}
				}
				return result;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.question {
	font-size: 16px;
	color: #202020;
	word-break: break-all;
	.optionMode {
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		.score {
			margin-left: 2px;
		}
	}
	.questionTitle {
		margin-top: 8px;
		font-size: 16px;
		font-weight: 400;
		white-space: pre-wrap;
	}
}
.done {
    color: #286BFF;
}
.done1 {
	color: #666666;
}
</style>
